import { render, staticRenderFns } from "./helpCenter.vue?vue&type=template&id=c9ef8674&scoped=true&"
var script = {}
import style0 from "./helpCenter.vue?vue&type=style&index=0&id=c9ef8674&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ef8674",
  null
  
)

export default component.exports